<bn-loading-overlay></bn-loading-overlay>

<div class="container" *ngIf="carregada; else carregando">
<form name="formLiberacao" #formLiberacao="ngForm" id="formLiberacao">
	<div class="row">
		<div class="col">
			<h3>Liberações para {{estadoInicial.idOperacaoAgente}}
				<small class="text-muted"> (Operação #ID: {{model?.id}})</small>
			</h3>
		</div>
		
		<!-- ng-template #meuId>
		<button class="btn btn-default " (click)="close()">Cancelar</button>
		<button class="btn btn-danger" (click)="salvar();dismiss()">Ok</button>
		</ng-template-->
	
		<div class="col-auto">
			<button *ngIf="formLiberacao.pristine"
				type="button" class="btn btn-danger" (click)="voltarParaLista ()">Cancelar</button>
			<button *ngIf="!formLiberacao.pristine" type="button" 
				class="btn btn-primary" bnConfirm tituloConfirm="Confirmação" msgConfirm="Descartar novas liberações e amortizações ?"
				(onConfirm)="voltarParaLista ()">Cancelar</button>
			<button id="btnSalvar" name="btnSalvar" [disabled]="!formLiberacao.valid" type="button" (click)="salvar ()"
				class="btn btn-primary" type="button">Enviar</button>
		</div>
	</div>

	<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="col nav-tabs"> 
		<li title="Liberações" *ngIf="model.liberacoes?.length > 0" [ngbNavItem]>
			<a ngbNavLink>Liberações</a>
			<ng-template ngbNavContent>
			<div class="table-responsive">
			<table class="table table-hover">
				<thead>
					<tr>
						<th scope="col"></th>
						<th scope="col">Nº liberação de crédito</th>
						<th scope="col">Data da liberação *</th>
						<th scope="col">Valor da liberação *</th>
					<tr>
				</thead>
				<tbody>
					<tr *ngFor="let lib of model.liberacoes; let i = index">
						<td><span *ngIf="!lib.id"><a (click)="removerLiberacao (i)"><i class="fa fa-trash cursor-pointer"></i></a></span></td>
						<td><span>{{ i+1 }}</span><span *ngIf="lib.id" > (Pré-existente)</span></td>							
						<td><bn-datepicker     name="data{{i}}"   [(ngModel)]="lib.data"  [disabled]="lib.id" required></bn-datepicker></td>
						<td><input type="text" name="valor{{i}}"  [(ngModel)]="lib.valor" [disabled]="lib.id" required class="form-control" bnMask="MOEDA" ></td>
					</tr>
				</tbody>
			</table>
			<a (click)="adicionarLiberacao ()"><i class="fa fa-plus-circle cursor-pointer"></i></a>
			</div>
			</ng-template> 
		</li> 
		<li title="Amortizações" [ngbNavItem]> 
			<a ngbNavLink>Amortizações</a>
			<ng-template ngbNavContent>
			<div class="table-responsive">
			<table class="table table-hover">
				<thead>
					<tr>
						<th scope="col"></th>
						<th scope="col">Data da amortização *</th>
						<th scope="col" class="coluna-moeda">Valor da amortização *</th>
					<tr>
				</thead>
				<tbody>
					<tr *ngFor="let amort of model.amortizacoes; let i = index">
						<td><span *ngIf="i > 0"><a
								(click)="removerAmortizacao(i)"><i
									class="fa fa-trash cursor-pointer"></i></a></span></td>
						<td><bn-datepicker name="dataAmortizacao{{i}}"
								[(ngModel)]="amort.data" required></bn-datepicker></td>
						<td class="coluna-moeda"><input type="text"
							class="form-control" name="valorAmortizacao{{i}}"
							[(ngModel)]="amort.valor" bnMask="MOEDA" required/></td>
					</tr>
				</tbody>
			</table>
			<a (click)="adicionarAmortizacao()"><i class="fa fa-plus-circle cursor-pointer"></i></a>
			</div>
			</ng-template> 
		</li> 
	</ul>

	<div [ngbNavOutlet]="nav"></div>
</form>
</div>

<div class="container" *ngIf="ocorrencias?.length > 0">
	<div class="table-responsive">
		<table class="table-striped table-bordered">
			<thead>
				<tr>
					<th class="text-center">Erro(s) encontrado(s)</th>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let ocorrencia of ocorrencias">
					<td>{{ ocorrencia.mensagem }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<ng-template #carregando>
<div class="loading-pesquisa">
	<i class="bn-loading"></i>
</div>
</ng-template>